import {
    DownOutlined,
    LogoutOutlined,
    // UserOutlined
} from '@ant-design/icons';
import { AccountInfo } from "@azure/msal-browser";
import { useAccount, useMsal, useIsAuthenticated } from "@azure/msal-react";
import { Badge, Dropdown, Flex } from "antd";
import { MenuItemType } from "antd/es/menu/interface";
import { useMemo, MouseEvent, useCallback } from "react";

import styles from './MSALBar.module.scss';

// import { MicrosoftIcon } from '../../assets/icons/microsoftIcon';
import { Description } from '../Description';
// import { Title } from '../Title';

export const MSALBar = () => {
    const { accounts } = useMsal();

    return (
        <Flex align="flex-center" gap={20} justify="flex-start" className={styles.root}>
            {/* {!isAuthenticated ? <AccountSwitcher accounts={accounts} /> : <Description theme="t1">active</Description>} */}
            <AccountSwitcher accounts={accounts} />
        </Flex>
    );
};

export const MsalStatus = () => {
    const isAuthenticated = useIsAuthenticated();
    return (
        <div>
            {isAuthenticated ? (
                <Badge status="success" text="connected" />
            ) : (
                <Badge status="error" text="disconnected" />
            )}
        </div>
    );
};

const AccountSwitcher = ({ accounts }: { accounts: AccountInfo[] }) => {
    const { instance } = useMsal();
    const activeAccount = useAccount(accounts[0] || {});

    const handleLogout = useCallback((e: MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        
        instance.logoutRedirect({
            postLogoutRedirectUri: window.location.href,
            account: activeAccount
        });
    }, [activeAccount, instance]);

    const items = useMemo(():MenuItemType[] => accounts.map((account) => ({
        key: account.idToken || account.homeAccountId || account.username || 'unknown',
        label: (
            <Flex style={{ width: "100%" }} justify="center" align="center" >
                <Flex vertical align="flex-start" gap={5} className={styles.accountInfo}>
                    {/* <Title tagName="h5" className={styles.accountTitle}>{account.name} </Title> */}
                    <Description theme="t6">{account?.username || account?.homeAccountId}</Description>
                </Flex>
                <LogoutOutlined onClick={handleLogout} style={{ marginLeft: 20, fontSize: 18, color: "red" }}/>
            </Flex>
        ),
    })), [accounts]);
    
    return (
        <Flex align="center" justify="center" gap={8} className={styles.accountSwitcher}>
            <MsalStatus />
            <Dropdown menu={{ items, selectable: true }} trigger={['click']} >        
                {accounts.length > 0 && <DownOutlined style={{ fontSize: 12, cursor: "pointer" }} />}
            </Dropdown>
        </Flex>
    );
}
